import Button from '../components/ui/Button';

export const goToExactSlide = function (slideIndex) {
	// check first if user is allowed to go to slide (slideIndex)
	// is only allowed to go to slide if all questions up to that slide (slideIndex) are answered

	// 1. Get all question IDs up to position 'slideIndex' that need to be answered
	const slides = this.state.slides;
	const questions = [];
	Object.keys(slides).map((key) => {
		if (slides[key].type === 'question' && key <= slideIndex) {
			questions.push(slides[key].ID);
		}
	});

	// 2. Get IDs of already answered questions
	const answeredQuestions = [];
	Object.keys(this.state.userData.dimensions).map((key) => {
		if ('results' in this.state.userData.dimensions[key]) {
			Object.keys(this.state.userData.dimensions[key].results).map((ID) => {
				answeredQuestions.push(parseInt(ID));
			});
		}
	});

	// 3. Check if all questions up to target slide are answered (exist in the answeredQuestions array)
	let goToSlide = true;
	for (let i = 0; i < questions.length; i++) {
		if (!questions.includes(answeredQuestions[i])) {
			goToSlide = false;
			break;
		}
	}

	if (goToSlide) {
		this.setState({
			position: slideIndex,
		});
	} else {
		console.error(`You're not allowed to go to the slide with the index ${slideIndex} because you didn't answer all necessary questions yet.`);
	}
};

export const goToPrevSlide = function () {
	let position = this.state.position;
	if (position > 0) {
		position--;
	}

	this.setState(
		{
			position,
		},
		() => {
			this.onSlideChange();
		},
	);
};

export const goToNextSlide = function () {
	let position = this.state.position;
	if (position < Object.keys(this.state.slides).length - 1) {
		position++;
	}

	const targetState = {
		position: position,
	};

	if (position > this.state.userData.progress) {
		targetState.userData = {
			...this.state.userData,
			progress: position,
		};
	}

	this.setState(targetState, () => {
		this.onSlideChange(true);
	});
};

export const onSlideChange = function (nextSlide = false) {
	// Push data to database (nextSlide determines if user has gone forwards / backwards)
	this.dbPushData(nextSlide);

	// Adjust scroll position
	const container = document.querySelector(`#ms-form-${this.state.id}`);
	if (container) {
		let offset = 100; // Default offset of 100px

		// Take care of WP admin bar
		if (document.querySelector('#wpadminbar')) {
			offset += document.querySelector('#wpadminbar').getBoundingClientRect().height;
		}

		const y = container.getBoundingClientRect().top + window.pageYOffset - offset;
		window.scrollTo({ top: y, behavior: 'smooth' });
	}
};

export const getDimensionDots = function () {
	const { dimensions, progress, callback } = this.props;
	return Object.keys(dimensions).map((key, index) => {
		const range = 100 / Object.keys(dimensions).length;
		const dotClasses = ['dot'];

		if (progress.handle >= index * range) {
			dotClasses.push(progress.handle >= (index + 1) * range ? 'done' : 'current');
		}

		return <div key={key} className={dotClasses.join(' ')} onClick={() => callback(dimensions[key].slide_start)} />;
	});
};

export const restartSurvey = function () {
	// Re-Init state
	this.setState(this.getInitialState());

	// Renew user ID
	this.generateUID(true);

	// Adjust scroll position
	this.onSlideChange();
};

export const showLeftNavButton = function () {
	const { position, resultsSlide, labels, restartBtnCallback, prevBtnCallback } = this.props;
	if (position === resultsSlide) {
		return <Button type="secondary" callback={restartBtnCallback} title={labels.btn_restart} blank={false} />;
	} else if (position > 0) {
		return <Button type="secondary" callback={prevBtnCallback} title={labels.btn_prev} blank={false} />;
	}
};

export const showRightNavButton = function () {
	const { position, slideCount, resultsSlide, labels, nextBtnCallback } = this.props;
	if (position < slideCount - 1) {
		const btnTitle = position === resultsSlide ? labels.btn_next_steps : labels.btn_next;
		return <Button type="primary" disabled={this.isNextBtnDisabled()} callback={nextBtnCallback} title={btnTitle} blank={false} />;
	}
};

export const isNextBtnDisabled = function () {
	const { slide, userData } = this.props;
	let show = true;
	if (slide.type === 'question') {
		show =
			slide.dimension in userData.dimensions && 'results' in userData.dimensions[slide.dimension] && slide.ID in userData.dimensions[slide.dimension].results;
	}
	return !show;
};
